import { Inversiones } from "../../components";
import "./stylesCategoriaInversiones.scss";

export const CategoriaInversiones = () => (
  <div>
    <Inversiones />
  </div>
);
